import React, { useState } from "react";
import "./DevicesSet.scss";
import { Button, CircularProgress } from "@mui/material";
import Header from "../../Home/Header/Header";

const DevicesSet = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [manualInput, setManualInput] = useState("");
  const [DataShow , setDataShow] = useState(false)

  const Data = [
    {
      TvSetId: 2,
      SetName: "Tv Content Set Two",
      Orientation: "Portrait (9:16)",
      Duration: 30,
      IsDefault: 1,
      IsActive: 1,
      IsPublish: 1,
      setMainImage: "http://nzen/R50B3/UFS/TV_APPS/FILES/1750251686084_3.jpg",
      EntryDate: "2025-06-28T10:02:20.120Z",
      LastUpdateDate: "2025-06-28T10:18:35.563Z",
      Files:
        '[{"Id":140,"FileName":"1750251686084_3.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251686084_3.jpg","DisplayOrder":1},{"Id":141,"FileName":"1750251686084_2.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251686084_2.jpg","DisplayOrder":2},{"Id":142,"FileName":"1750251686084_1.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251686084_1.jpg","DisplayOrder":3},{"Id":143,"FileName":"1750251686084_4.mp4","Type":"video/mp4","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251686084_4.mp4","DisplayOrder":4}]',
    },
    {
      TvSetId: 3,
      SetName: "Tv Content Set Three",
      Orientation: "Landscape (16:9)",
      Duration: 30,
      IsDefault: 0,
      IsPublish: 0,
      setMainImage: "http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_9.jpg",
      IsActive: 1,
      EntryDate: "2025-06-28T10:02:20.120Z",
      LastUpdateDate: "2025-06-28T10:02:20.120Z",
      Files:
        '[{"Id":13,"FileName":"1750251715147_2.webp","Type":"image/webp","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_2.webp","DisplayOrder":1},{"Id":16,"FileName":"1750251715147_5.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_5.jpg","DisplayOrder":4},{"Id":12,"FileName":"1750251715147_1.gif","Type":"image/gif","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_1.gif","DisplayOrder":6},{"Id":18,"FileName":"1750251715147_7.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_7.jpg","DisplayOrder":7},{"Id":19,"FileName":"1750251715147_8.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_8.jpg","DisplayOrder":8},{"Id":20,"FileName":"1750251715147_9.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_9.jpg","DisplayOrder":9},{"Id":21,"FileName":"1750251715147_10.mp4","Type":"video/mp4","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251715147_10.mp4","DisplayOrder":10}]',
    },
    {
      TvSetId: 4,
      SetName: "Tv Content Set Four",
      Orientation: "Portrait (9:16)",
      Duration: 30,
      IsPublish: 0,
      IsDefault: 0,
      setMainImage: "http://nzen/R50B3/UFS/TV_APPS/FILES/1750251738340_2.webp",
      IsActive: 1,
      EntryDate: "2025-06-28T10:02:20.120Z",
      LastUpdateDate: "2025-06-28T10:02:20.120Z",
      Files:
        '[{"Id":24,"FileName":"1750251738340_2.webp","Type":"image/webp","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251738340_2.webp","DisplayOrder":1},{"Id":28,"FileName":"1750251738340_6.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251738340_6.jpg","DisplayOrder":2},{"Id":23,"FileName":"1750251738340_1.gif","Type":"image/gif","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251738340_1.gif","DisplayOrder":3},{"Id":25,"FileName":"1750251738340_3.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251738340_3.jpg","DisplayOrder":4},{"Id":26,"FileName":"1750251738340_4.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251738340_4.jpg","DisplayOrder":5},{"Id":27,"FileName":"1750251738340_5.jpg","Type":"image/jpeg","Url":"http://nzen/R50B3/UFS/TV_APPS/FILES/1750251738340_5.jpg","DisplayOrder":6}]',
    },
  ];
  const handleManualSave = () => {
    manualInput?.length !== 0 && setDataShow(true);  
    setManualInput('');
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}
      <Header otherPage={true} title="Device Set" />
      <div className="devicesSet_main">
        <div className="manual-input">
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: "5px",
              alignItems: "center",
              justifyContent: "center",
              gap: "7px",
            }}
          >
            <input
              type="text"
              value={manualInput}
              onChange={(e) => setManualInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleManualSave();
                }
              }}
              placeholder="Enter Device Name"
            />
            <button onClick={handleManualSave}>Save</button>
          </div>
        </div>
      </div>
      {DataShow && (
        <div className="designSet_mainDiv">
          {Data?.map((data, index) => (
            <div key={index}>
              <div className="setDesignMainBox">
                <div>
                  <img
                    src={data?.setMainImage}
                    style={{ width: "100px", height: "100%" }}
                  />
                </div>
                <div>
                  <p
                    style={{ margin: "5px", fontSize: "14px", fontWeight: 600 }}
                  >
                    {data?.SetName}
                  </p>

                  <p style={{ margin: "5px", fontSize: "12px" }}>
                    {data?.Orientation}
                  </p>
                </div>
                <div
                  style={{
                    position: "absolute",
                    right: "20px",
                    bottom: "10px",
                  }}
                >
                  {data?.IsPublish == 0 ? (
                    <Button className="Publish_btn">Publish</Button>
                  ) : (
                    <div style={{ display: "flex", gap: "10px" }}>
                      <p
                        style={{
                          margin: "0px",
                          fontWeight: 600,
                          color: "green",
                          fontSize: "12px",
                        }}
                      >
                        Active Live
                      </p>
                      <Button
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "red",
                          margin: "0px",
                          textDecoration: "underline",
                          padding: "0px",
                          textTransform: "capitalize",
                        }}
                      >
                        Unpublish
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
          <div></div>
        </div>
      )}
    </div>
  );
};

export default DevicesSet;
